import { Injectable } from "@angular/core";
import { LoggingService } from "../logging.service";

@Injectable()
export class LeaveLoggerService {
  constructor(private logger: LoggingService) {
    window.addEventListener('beforeunload', () => {
      this.logger.logLastLogs();
    });
  }
}